import React, {useEffect, useState} from 'react';
import {
    Button,
    Checkbox,
    Flex,
    Form,
    Image,
    Input,
    message,
    Progress,
    Upload,
    Card as AntdCard,
    DatePicker, ConfigProvider, Select
} from "antd";
import Card from "../../../../components/LoadingComponents/Card";
import MyMasonry from "../../../../components/Masonry/MyMasonry";
import {useDispatch, useSelector} from "react-redux";
import {useWindowSize} from "@uidotdev/usehooks";
import {useNavigate} from "react-router-dom";
import Chart from "react-apexcharts";
import classes from './chart/chart.module.css';
import cl from '../../../global_styles.module.css';
import ru_RU from "antd/lib/locale/ru_RU";
import ru from "apexcharts/dist/locales/ru.json";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {UserOutlined} from "@ant-design/icons";
import FormItem from "antd/es/form/FormItem";
import SteveBloxButton from "../../../../components/UI/Buttons/SteveBloxButton";
import {Emissions} from "../../../../constants/emissions";
import EmissionService from "../../../../services/EmissionService";

const { RangePicker } = DatePicker;

const HomePage = () => {
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const size = useWindowSize();

    const [form] = Form.useForm();
    const dates = Form.useWatch('dates', form);
    const emissions = Form.useWatch('emissions', form);

    const [emissionTrends, setEmissionTrends] = useState([]);

    function convertDateFormat(dateString) {
        // Split date and time parts
        const parts = dateString.split(', ');
        const datePart = parts[0];
        const timePart = parts[1];

        // Split date into dd, mm, yyyy
        const dateComponents = datePart.split('.');
        const day = dateComponents[0];
        const month = dateComponents[1];
        const year = dateComponents[2];

        // Time part is already in correct hh:mm:ss format
        // Rearrange to yyyy-mm-ddThh:mm:ss format
        return `${year}-${month}-${day}T${timePart}`;
    }

    function handleOnSubmit() {
        form.validateFields()
            .then(async () => {
                setLoading(true);

                let newEmissionTrends = [];
                const fromTimestamp = convertDateFormat(new Date(dates[0]).toLocaleString());
                const toTimestamp = convertDateFormat(new Date(dates[1]).toLocaleString());
                for (const emission of emissions) {
                    await EmissionService.getTrends(emission, fromTimestamp, toTimestamp)
                        .then((r) => {
                            // console.log(r.data);

                            newEmissionTrends.push(
                                {
                                    data: r.data.map((data) => {
                                        return (
                                            {
                                                x: new Date(data.timestamp),
                                                y: data.value
                                            }
                                        )
                                    }),
                                    name: emission,
                                }
                            )
                        })
                        .catch((r) => {

                        })
                }
                setEmissionTrends(newEmissionTrends);
                setLoading(false);
            })
            .catch(() => {

            })
    }

    const config = {
        options: {
            chart: {
                id: 'area-datetime',
                type: 'area',
                height: 350,
                zoom: {
                    autoScaleYaxis: true
                },
                locales: [ru],
                defaultLocale: "ru",
            },
            // annotations: {
            //     yaxis: [{
            //         y: 30,
            //         borderColor: '#999',
            //         label: {
            //             show: true,
            //             text: 'Support',
            //             style: {
            //                 color: "#fff",
            //                 background: '#00E396'
            //             }
            //         }
            //     }],
            //     xaxis: [{
            //         // x: new Date('14 Nov 2012').getTime(),
            //         borderColor: '#999',
            //         yAxisIndex: 0,
            //         label: {
            //             show: true,
            //             text: 'Rally',
            //             style: {
            //                 color: "#fff",
            //                 background: '#775DD0'
            //             }
            //         }
            //     }]
            // },
            dataLabels: {
                enabled: false
            },
            markers: {
                size: 0,
                style: 'hollow',
            },
            xaxis: {
                type: 'datetime',
                // min: new Date('01 Mar 2012').getTime(),
                tickAmount: 6,
            },
            tooltip: {
                x: {
                    format: 'dd MMM yyyy hh:mm'
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.2,
                    opacityTo: 0.7,
                    stops: [0, 100]
                }
            },
        },

        series: emissionTrends,
        selection: 'emissions',
    };

    // if (loading) {
    //     return (
    //         <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={10}>
    //             <MyMasonry>
    //                 {/*<Card type={'horizontal-circle'}/>*/}
    //                 {/*<Card type={'calendar'}/>*/}
    //                 <Card type={'horizontal'}/>
    //                 <Card type={'horizontal'}/>
    //                 <Card type={'horizontal'}/>
    //                 <Card type={'horizontal'}/>
    //                 {/*<Card type={'horizontal'}/>*/}
    //                 {/*<Card type={'horizontal'}/>*/}
    //                 {/*<Card type={'horizontal'}/>*/}
    //             </MyMasonry>
    //         </Flex>
    //     );
    // }

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical wrap={"wrap"} gap={10}>
            {/*<MyMasonry>*/}
            <Form form={form} style={{maxWidth: 500}} className={cl.form}>
                <ConfigProvider locale={ru_RU}>
                    <FormItem
                        rules={[
                            {
                                required: true,
                                message: <IntlMessage id={'requiredField'}/>,
                            },
                        ]}
                        className={cl.formInputBlock} name="dates">
                        <RangePicker locale={"ru-RU"} format={"YYYY-MM-DD HH:mm"} showTime />
                    </FormItem>
                </ConfigProvider>
                <FormItem
                    rules={[
                        {
                            required: true,
                            message: <IntlMessage id={'requiredField'}/>,
                        },
                    ]}
                    className={cl.formInputBlock} name="emissions">
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        // placeholder="Please select"
                        defaultValue={[]}
                        // onChange={(value) => {console.log(value)}}
                        options={Object.values(Emissions).map((value) => ({label: value, value: value}))}
                    />
                </FormItem>


                <SteveBloxButton onClick={handleOnSubmit}>
                    <IntlMessage id={'search'}/>
                </SteveBloxButton>
            </Form>


            {/*</MyMasonry>*/}
            {
                loading ?
                    <Card type={'horizontal'}/>
                    :
                    <Chart
                        options={config.options}
                        series={config.series}
                        type="area"
                        height={350}
                        className={classes.chart}
                    />
            }

        </Flex>
    );
};

export default HomePage;